import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import authService from '../../services/auth';
import './Login.css';
// @ts-ignore
import background from './login_background.jpg';
import TextField from '../TextField/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Visibility, VisibilityOff, Email } from '@material-ui/icons';
import logo from './scisports-logo.svg';
import tokenProvider from '../../utils/token';

const Wrapper = styled.div`
  width: 479px;
  height: 100%;
  overflow: hidden;
`;

const Semitransparent = styled.div`
  height: 100%;
  width: 500px;
  background: url(${background}) no-repeat center center fixed;
  filter: blur(10px);
  top: 0px;
  left: -100px;
  right: -100px;
  overflow: hidden;
  background-size: cover;
`;

const LoginWrapper = styled.div`
  height: 100%;
`;

const LoginDialog = styled.div`
  position: absolute;
  width: 461px;
  height: 595px;
  left: 160px;
  top: calc(50% - 300px);
  background-color: white;
`;

const BallJamesLogo = styled.img`
  padding-top: 39px;
  display: block;
  margin: auto;
  width: 350px;
`;

const EmailField = styled(TextField)`
  margin: auto;
`;

const PasswordField = styled(TextField)`
  margin: auto;
`;

const LoginButtonWrapper = styled.div`
  width: 370px;
  margin: auto;
  margin-top: 63px;
`;

interface Props {
  history: any;
}

const Login = (props: Props) => {
  let [email, setEmail] = useState('');
  let [password, setPassword] = useState('');
  let [showPassword, setShowPassword] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onLogin = async (event: any) => {
    event.preventDefault();
    
    try {
      const result = await authService.login({ email, password });

      tokenProvider.setToken(result.token);
      props.history.push('/sessions');
    }
    catch {
      enqueueSnackbar('Login failed', { variant: 'error', autoHideDuration: 3000 })
    }
  };

  useEffect(() => {
    document.body.classList.add('login-body');
    return () => {
      document.body.classList.remove('login-body');
    };
  });

  return (
    <LoginWrapper>
      <Wrapper>
        <Semitransparent />
      </Wrapper>
      <LoginDialog>
        <form onSubmit={onLogin}>
          <BallJamesLogo src={logo} />
          <EmailField
            id="email"
            placeholder="Email"
            label="Email"
            value={email}
            width={370}
            onChange={(event) => setEmail(event.target.value)}
            inputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <Email />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <PasswordField
            id="password"
            label="Password"
            value={password}
            width={370}
            onChange={(event) => setPassword(event.target.value)}
            type={showPassword ? 'text' : 'password'}
            inputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="Toggle password visibility" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <LoginButtonWrapper>
            <Button size="large" variant="contained" color="primary" type="submit" fullWidth>
              Login
            </Button>
          </LoginButtonWrapper>
        </form>
      </LoginDialog>
    </LoginWrapper>
  );
};

export default Login;
